import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "@/components/base/Logo";
import SearchBar from "@/components/base/SearchBar";
import { getCategories } from "@/lib/navData";

export default function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();
  const categories = getCategories();

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  const navItem = (path: string, label: string) => (
    <Link
      key={path}
      to={path}
      onClick={() => setMobileOpen(false)}
      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
        isActive(path)
          ? "text-primary-600 bg-primary-100/70"
          : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="max-w-page mx-auto px-4 md:px-6 h-16 flex items-center gap-4">
        <Logo />

        <nav className="hidden md:flex items-center gap-1 ml-2">
          {navItem("/", "首页")}

          <div
            className="relative"
            onMouseEnter={() => setCategoryOpen(true)}
            onMouseLeave={() => setCategoryOpen(false)}
          >
            <button
              type="button"
              onClick={() => setCategoryOpen((v) => !v)}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1 ${
                isActive("/category")
                  ? "text-primary-600 bg-primary-100/70"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              分类导航
              <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? "rotate-180" : ""}`} />
            </button>

            {categoryOpen && (
              <div className="absolute left-0 top-full pt-2 w-[560px]">
                <div className="bg-background-50 border border-background-200 rounded-xl p-3 grid grid-cols-3 gap-1 shadow-sm">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${encodeURIComponent(cat.id)}`}
                      onClick={() => setCategoryOpen(false)}
                      className="flex items-center gap-2 px-2.5 py-2 rounded-lg hover:bg-primary-100/60 transition-colors cursor-pointer"
                    >
                      <span className="w-7 h-7 rounded-md bg-background-100 text-primary-600 flex items-center justify-center shrink-0">
                        <i className={`${cat.icon} text-sm`} />
                      </span>
                      <span className="text-sm text-foreground-800">{cat.name}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {navItem("/about", "关于我们")}
          {navItem("/contact", "联系我们")}
        </nav>

        <div className="hidden md:block w-[190px] lg:w-[260px] ml-auto">
          <SearchBar />
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="切换菜单"
          className="md:hidden ml-auto w-10 h-10 rounded-md border border-background-200 text-foreground-700 flex items-center justify-center cursor-pointer"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <div className="mb-4">
            <SearchBar />
          </div>
          <div className="flex flex-col gap-1">
            {navItem("/", "首页")}
            {navItem("/about", "关于我们")}
            {navItem("/contact", "联系我们")}
          </div>
          <p className="text-xs text-foreground-400 mt-4 mb-2 px-1">热门分类</p>
          <div className="grid grid-cols-2 gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${encodeURIComponent(cat.id)}`}
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-2 px-2.5 py-2 rounded-lg hover:bg-primary-100/60 transition-colors cursor-pointer"
              >
                <span className="w-7 h-7 rounded-md bg-background-100 text-primary-600 flex items-center justify-center shrink-0">
                  <i className={`${cat.icon} text-sm`} />
                </span>
                <span className="text-sm text-foreground-800">{cat.name}</span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}